export default "https://cdn-static.gokick.com/assets/d6a1d1f7abc93216fd07fb40adb7adf28904b072/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";